import React, { Suspense } from "react";
import Loading from "../Loading";

const PageSuspense = ({ children }) => {
  return <Suspense fallback={<Loading />}>{children}</Suspense>;
};

export default PageSuspense;
